/**
 * Dialog now lives in the shared design system, @atomic/ui-kit — shared with
 * chomps so a fix lands in both at once. Thin re-export shim: every existing
 * `import { Dialog, DialogContent, ... } from ".../ui/dialog"` keeps working.
 */
export {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@atomic/ui-kit"
